import { useCallback } from 'react'
import { ToTagPropsFn } from '../../../types'
import { LabTechTagLabTech } from '../types'
import { useUserTagProps } from '../../UserTags/hooks/useUserTagProps'

/**
 * a callback to transform a Lab Tech to the tags prop of a CIMSTags component
 */
export function useLabTechTagProps() {
  const userTagProps = useUserTagProps({ color: 'processing' })
  const callback = useCallback<ToTagPropsFn<LabTechTagLabTech>>(
    ({ name, user }) => {
      if (!!user) return userTagProps(user)
      return { text: name, tooltip: 'Generic' }
    },
    [userTagProps]
  )

  return callback
}
